// API-функции Stage 5: банковские операции (контракт §3/§5).
// Вынесены в отдельный модуль: endpoints.ts периодически синхронизируется
// внешним процессом (см. маркер __SYNC_PROBE__ в конце файла) — правки в нём
// теряются, поэтому новые вызовы живут здесь.
// Формат — как у finance в endpoints.ts: apiList/apiCommand/apiGet.

import { apiCommand, apiGet, apiList } from './client';
import type { BankOperation, Invoice, Payment } from './types';

/** Детали платежа/счёта (detail-роуты DRF viewset). */
export function paymentDetail(id: string) {
  return apiGet<Payment>(`/finance/payment/${id}/`);
}

export function invoiceDetail(id: string) {
  return apiGet<Invoice>(`/finance/invoice/${id}/`);
}

/** Список банковских операций; фильтры: status, source. */
export function listBankOperations(params?: Record<string, unknown>) {
  return apiList<BankOperation>('/finance/bank-operation/', params);
}

export function getBankOperation(id: string) {
  return apiGet<BankOperation>(`/finance/bank-operation/${id}/`);
}

export interface BankOperationMatchResult {
  operation_id: string;
  operation_revision: number;
  status: string;
  payment_id: string;
  payment_revision: number;
}

/** Сопоставление операции: payer_id обязателен; payment_id — привязка к
    существующему PENDING-платежу, иначе backend создаёт новый. */
export function matchBankOperation(
  id: string,
  body: { payer_id: string; invoice_id?: string | null; payment_id?: string | null; revision?: number },
) {
  return apiCommand<BankOperationMatchResult>(`/finance/bank-operation/${id}/match/`, body);
}

/** Отклонение received-операции с примечанием. */
export function rejectBankOperation(id: string, body: { note: string; revision?: number }) {
  return apiCommand<{ operation_id: string; operation_revision: number; status: string }>(
    `/finance/bank-operation/${id}/reject/`, body);
}
